export class BrowserEventsConstants {

  static readonly WINDOW_RESIZE: string = 'resize';
}